/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Prose/theme';

export const ProseTheme = theme;
